import API, {config} from './_main';
import {AxiosPromise} from 'axios';
import {Types} from 'Models/TerminalInstallationModel';
import {EnumTypes} from "Models/EnumTypes/TerminalInstallationEnumTypes";

export function createTerminalInstallationOrder(formData: any) {
    return API.post('/terminal-installation-order', formData, config());
}

export function editTerminalInstallationOrder(formData: Types.EditTerminalInstallationRequest, terminalInstallationOrderId: number): AxiosPromise<Types.GetTerminalInstallationOrderByIdResponse> {
    return API.put(`/terminal-installation-order/${terminalInstallationOrderId}`, formData, config());
}

export function setDateTerminalInstallation(formData: Types.SetDateTerminalInstallationRequest, terminalInstallationOrderId: number) {
    return API.post(`/terminal-installation-order/${terminalInstallationOrderId}/installation-date`, formData, config());
}

export function getTerminalInstallationOrderList(queryParams?: URLSearchParams): AxiosPromise<Types.GetTerminalInstallationOrderListResponse> {
    return API.get('/terminal-installation-order', config(queryParams));
}

export function getTerminalInstallationOrderById(terminalInstallationOrderId: number): AxiosPromise<Types.GetTerminalInstallationOrderByIdResponse> {
    return API.get(`/terminal-installation-order/${terminalInstallationOrderId}`, config());
}

export function cancelTerminalInstallationOrders(terminalInstallationOrderId: number) {
    return API.post(`/terminal-installation-order/${terminalInstallationOrderId}/cancel`, null, config());
}

export function confirmTerminalInstallation(terminalInstallationOrderId: number) {
    return API.post(`/terminal-installation-order/${terminalInstallationOrderId}/confirm`, null, config());
}

export function cancelInstallationDate(terminalInstallationOrderId: number) {
    return API.post(`/terminal-installation-order/${terminalInstallationOrderId}/cancel-installation-date`, null, config());
}

export function getTerminalInstallationReportFile(terminalInstallationId?: number) {
    return API.get(`/terminal-installation-order/${terminalInstallationId}/report`, {responseType: 'blob'});
}

export function getTechnicianList(queryParams?: URLSearchParams) {
    return API.get(`/user/technician`, config(queryParams));
}

export function getTerminalInstallationOrderHistory(terminalInstallationId?: number) {
    return API.get(`/terminal-installation-order/${terminalInstallationId}/history`, config());
}

export function setTerminalInstallationNote(index: number, noteData: string) {
    return API.post(`/terminal-installation-order/${index}/comment`, {comment: noteData}, config());
}

export function getTerminalInstallationNotes(index: number) {
    return API.get(`/terminal-installation-order/${index}/comment`, config());
}

export function updateTerminalInstallationVin(index: number, vin: string) {
    return API.patch(`/terminal-installation-order/${index}/vin`, {vin}, config());
}

export function updateTerminalInstallationPhotos(index: number, photos: FormData, category: EnumTypes.CarPictureType) {
    return API.post(`file/terminal-installation-order/${index}/photo?carPictureType=${category}`, photos, config());
}



// WEBPACK FOOTER //
// ./src/Connectors/TerminalInstallationConnector.ts